module.exports = __webpack_public_path__ + "static/img/2.6028fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/2.png
// module id = NPZL
// module chunks = 4